
















import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { SignUpForm } from '../types/SignUpForm';
import DpButton from '../../../components/atoms/DpButton/index.vue';
import DpCheckbox from '../../../components/atoms/DpCheckbox/index.vue';
import DpInput from '../../../components/atoms/DpInput/index.vue';
import SocialAuth from '../../../components/organisms/SocialAuth/index.vue';
import DpUnderlinedLink from '../../../components/molecules/DpUnderlinedLink/index.vue';
import SvgIcon from '../../../components/SvgIcon.vue';

@Component({
  name: 'SocialProfile',
  components: {},
})
export default class SocialProfile extends Vue {
  @Prop() imageUrl?: string;

  @Prop() name?: string;

  @Prop() email?: string;
}
